import { inject, Injectable, signal, effect } from "@angular/core";
import { AuthService } from "../../../../../core/services/auth/auth.service";
import { Module } from "../../../../../core/services/roles-permissions/types";
import { Action } from "../../../../../core/services/auth/types/auth-user.type";

@Injectable({
    providedIn: 'root'
})
export class SidebarStore {
    private readonly authService = inject(AuthService);

    constructor() {
        effect(() => {
            const actions = this.authService.actions();
            if (actions.length > 0) {
                this.saveActionsToLocalStorage(actions);
            }
            // No eliminamos localStorage aquí para evitar limpiar datos en refresh
        });
    }

    getSidebarByRoleId() {
        const actions = this.authService.getActions();
        if (actions.length > 0) {
            this.saveActionsToLocalStorage(actions);
        }
    }

    getSidebar() {
        return {
            modules: this.authService.getModules(),
            actions: this.authService.getActions()
        };
    }

    getMainMenuModules(): Module[] {
        const modules = this.authService.getModules();
        return modules
            .filter(module => module.showInMainMenu)
            .sort((a, b) => a.order - b.order);
    }

    getSettingsModules(): Module[] {
        const modules = this.authService.getModules();
        return modules
            .filter(module => !module.showInMainMenu)
            .sort((a, b) => a.order - b.order);
    }

    private saveActionsToLocalStorage(actions: Action[]): void {
        localStorage.setItem('userActions', JSON.stringify(actions));
    }
}